import { useEffect, useState } from 'react';
import * as Fnctn from '../../contexts/GenericFunctions';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import { Button } from 'devextreme-react';
import { Await, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as CRS_actions from '../../reduxStore/Courses/ViewCourse/CRS_action';
import styles from '../../pages/Cuorses/CoursePg.module.scss'

interface IProps {
    status: any
}

const Get_Courses_User = ({ status }: IProps) => {
    const [arrayDiv, setArrayDiv] = useState<any>([]);

    useEffect(() => {
        halcoloaderActive();
        GetData_CoursesUser();
    }, []);

    const nav = async (navigate: any, dispatch: any, props: { [key: string]: any }) => {
        dispatch(CRS_actions.set_course_id(props._id))
        dispatch(CRS_actions.set_course_selected_index(0))
        await navigate('/View_Cursos')
    }

    const TaskItem = (props: any) => {
        const navigate = useNavigate();
        const dispatch = useDispatch();

        return (
            <Button onClick={() => { nav(navigate, dispatch, props) }} className={`${styles.btnTarea}`}>
                <div className={`${styles.IconoTarea}`}>
                    <img className={`${styles.ImgIcono}`} src={Fnctn.NullUndefinedEmpty(props.img_path) ? 'https://firebasestorage.googleapis.com/v0/b/halconet-27dd9.appspot.com/o/HalcoHumand%2FICONOS_TAREAS%2Flogo-halconet_sinletras.svg?alt=media&token=cd51f543-4a9b-4685-85f7-50f9976b4146' : props.img_path} alt='Img' />
                </div>
                <div className={`${styles.TareaItem}`}>
                    <div style={{ display: "grid", justifyContent: "center", margin: "20px 0px 5px 25px" }}>
                        <label style={{ fontWeight: 'bold', fontSize: "20px" }}>Curso </label>
                        <label className={`${styles.task_item_text}`} style={{ whiteSpace: "normal", placeItems: "center" }}>{props.course}</label>
                    </div>
                </div>
                <div className={`${styles.TareaItem}`}>
                    <div style={{ display: "grid", justifyContent: "center", margin: "20px 0px 5px 25px" }}>
                        <label style={{ fontWeight: 'bold', fontSize: "20px" }}>Seguimiento </label>
                        <label className={`${styles.task_item_text}`} style={{ whiteSpace: "normal", placeItems: "center" }}>{props.complete_evaluations} / {props.total_evaluations}</label>
                    </div>
                </div>
            </Button>
        );
    };

    const GetData_CoursesUser = async () => {
        try {
            const data = Fnctn.getCookie();
            const Objt = {
                cvetra: data.cvetra,
                status: status
            };

            const response = await Fnctn.postData(`/training/get_pending_courses_user`, "PUT", Objt);
            const dtResult = await response.json();

            if (dtResult.valid) {
                const taskItems = dtResult.data.map((item: any) => (
                    <div><TaskItem key={item.id} {...item} /><br /></div>
                ));
                setArrayDiv(taskItems);
            } else {
                throw new Error(dtResult.message);
            }
            halcoloaderRemove();
        }
        catch (error) {
            halcoloaderRemove();
        }
    };

    return (
        <div>
            {arrayDiv.length > 0 ? arrayDiv : <div>No hay cursos disponibles.</div>}
        </div>
    );
};

export default Get_Courses_User;
